export default __webpack_public_path__ + "static/media/lamp2.f39f8eef.webp";